'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extractPrefixedAttributesFromElement = require('./src/extract-prefixed-attributes-from-element');

Object.defineProperty(exports, 'extractPrefixedAttributesFromElement', {
  enumerable: true,
  get: function get() {
    return _extractPrefixedAttributesFromElement.extractPrefixedAttributesFromElement;
  }
});

var _parseStringAsDom = require('./src/parse-string-as-dom');

Object.defineProperty(exports, 'parseStringAsDom', {
  enumerable: true,
  get: function get() {
    return _parseStringAsDom.parseStringAsDom;
  }
});

var _listenForAddedElements = require('./src/listen-for-added-elements');

Object.defineProperty(exports, 'listenForAddedElements', {
  enumerable: true,
  get: function get() {
    return _listenForAddedElements.listenForAddedElements;
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/dom-utility/index.js
// module id = 61
// module chunks = 0 2